import { IValidationFunction } from "aic";

/**
 * Validates a name for uniqueness and format
 *
 * @param _ - Not used
 * @param target - The target string to validate as a name
 * @returns Promise<IValidReturn>
 */
export const checkName: IValidationFunction = async (_, target) => {
  let valid = false;
  let validationText: string = "Not validated";
  if (target.value.trim() === "") {
    valid = false;
    validationText = "Name cannot be blank";
  } else if (
    (target.options?.existingValues ?? []).findIndex(
      (s) => s.trim().toLowerCase() === target.value.trim().toLowerCase(),
    ) >= 0
  ) {
    valid = false;
    validationText = "This name is taken";
  } else if (target.value.trim().match(/^[A-Za-z0-9_ -]*$/) === null) {
    valid = false;
    validationText = "Only alphanumeric characters and -_ can be used";
  } else {
    valid = true;
    validationText = "Successfully validated";
  }
  return { success: true, data: { valid, validationText } };
};
